export default __webpack_public_path__ + "eefeac5b89bedc427799277f2d03a8d5.obj";